export default __webpack_public_path__ + "images/c467a967980e881a095a1677aeb3201a.svg";